import { render, staticRenderFns } from "./AccessView.vue?vue&type=template&id=6ef90763&scoped=true"
import script from "./AccessView.vue?vue&type=script&lang=js"
export * from "./AccessView.vue?vue&type=script&lang=js"
import style0 from "./AccessView.vue?vue&type=style&index=0&id=6ef90763&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef90763",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/_work/studio-admin/studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ef90763')) {
      api.createRecord('6ef90763', component.options)
    } else {
      api.reload('6ef90763', component.options)
    }
    module.hot.accept("./AccessView.vue?vue&type=template&id=6ef90763&scoped=true", function () {
      api.rerender('6ef90763', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccessView.vue"
export default component.exports